import React from 'react';
import ReactDOM from 'react-dom';
import { BlocNotesApp } from './BlocNotesApp';

import './styles/styles.scss';

ReactDOM.render(
    <BlocNotesApp />,
    document.getElementById('root')
);